/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrganizationAdminAddGroup
 */
export interface OrganizationAdminAddGroup {
    /**
     * 
     * @type {string}
     * @memberof OrganizationAdminAddGroup
     */
    org_code: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationAdminAddGroup
     */
    new_group_name: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationAdminAddGroup
     */
    organization_azure_id: string;
}

/**
 * Check if a given object implements the OrganizationAdminAddGroup interface.
 */
export function instanceOfOrganizationAdminAddGroup(value: object): value is OrganizationAdminAddGroup {
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('new_group_name' in value) || value['new_group_name'] === undefined) return false;
    if (!('organization_azure_id' in value) || value['organization_azure_id'] === undefined) return false;
    return true;
}

export function OrganizationAdminAddGroupFromJSON(json: any): OrganizationAdminAddGroup {
    return OrganizationAdminAddGroupFromJSONTyped(json, false);
}

export function OrganizationAdminAddGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationAdminAddGroup {
    if (json == null) {
        return json;
    }
    return {
        
        'org_code': json['org_code'],
        'new_group_name': json['new_group_name'],
        'organization_azure_id': json['organization_azure_id'],
    };
}

export function OrganizationAdminAddGroupToJSON(json: any): OrganizationAdminAddGroup {
    return OrganizationAdminAddGroupToJSONTyped(json, false);
}

export function OrganizationAdminAddGroupToJSONTyped(value?: OrganizationAdminAddGroup | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_code': value['org_code'],
        'new_group_name': value['new_group_name'],
        'organization_azure_id': value['organization_azure_id'],
    };
}

